<main class="dashboard">
  <h1>
    <ng-container *ngIf="statusCard && !isVoucherView">
      <span
        *ngIf="((loanCard && (loanCard.cardType === 2 || loanCard.cardType === 6)) || (!loanCard && statusCard?.cardType === 2)) && !isDeclined">Congratulations</span>
      <span
        *ngIf="!((loanCard && (loanCard.cardType === 2 || loanCard.cardType === 6)) || (!loanCard && statusCard?.cardType === 2)) && !isDeclined">Welcome</span>
      <span *ngIf="!states || isDeclined">Sorry</span>
      <span *ngIf="customer?.name">, {{customer.name}}</span>!
    </ng-container>
  </h1>
  <div class='confetti-wrapper' *ngIf='showConfetti' [class.show]='showModal'>
    <canvas id="confetti" class="confetti"></canvas>
    <div class='congratulations' [class.show]='showCongrats'>
      <div class="approved-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
          <g fill="none" stroke="#1eba68" stroke-width="10">
            <circle cx="77" cy="77" r="72" style="stroke-dasharray:480px, 480px; stroke-dashoffset: 960px;"></circle>
            <circle id="colored" fill="#1eba68" cx="77" cy="77" r="72"
              style="stroke-dasharray:480px, 480px; stroke-dashoffset: 960px;"></circle>
            <polyline class="st0" stroke="#fff" stroke-width="10" points="43.5,77.8 63.7,97.9 112.2,49.4 "
              style="stroke-dasharray:100px, 100px; stroke-dashoffset: 200px;" />
          </g>
        </svg>
      </div>
      <h1>Congratulations!</h1>
      <div>Your voucher is approved</div>
    </div>
  </div>
  <!-- Show CL Increase above Primary card -->
  <section *ngIf="showCLiCard && cliAsPrimaryCard">
    <zest-cl-increase-card [primaryCard]="cliAsPrimaryCard"></zest-cl-increase-card>
  </section>
  <section class="status-section">
    <!-- Show Status Card for CL journey -->
    <zest-status-card *ngIf="!loanCard && !isDeclined && statusCard && !showDocUpload" [statusCard]="statusCard"
      (action)="continue()">
    </zest-status-card>
    <!-- Show Loan Card for loan journey -->
    <zest-loan-status-card *ngIf="loanCard && !isDeclined && !showDocUpload" [loanCard]="loanCard" [states]='states'
      [clState]='clState' [currentApplication]='currentApplication' [approvedApplications]="allApprovedGCApplications"
      (refresh)="refreshDashboard()" (voucherView)="setVoucherView($event)"></zest-loan-status-card>
    <!-- Show Declined Card -->
    <zest-declined-card *ngIf="isDeclined" [code]="declinedCode"></zest-declined-card>
  </section>
  <section *ngIf="showCLiCard && !cliAsPrimaryCard">
    <zest-cl-increase-card [primaryCard]="cliAsPrimaryCard"></zest-cl-increase-card>
  </section>
  <section class="info-section" *ngIf="!isVoucherView">
    <!-- Shop now -->
    <div class="new-card primary additional-card" *ngIf="showShopOption && !flipkartUltraFlowEnabled">
      <div class="card-info">
        <h3>Shop before activation?</h3>
        Browse 1000+ partners
      </div>
      <button class="btn zest-btn outline" (click)="shopOnApprovedCL()">SHOP</button>
    </div>
    <!-- Upload Additional Details -->
    <div class="new-card primary additional-card" *ngIf="showAdditionalDocUpload && !showDocUpload && !googlepayFlowEnabled">
      <div class="card-info">
        Upload any additional documents, if asked by <strong>our team via phone, email or SMS</strong>
      </div>
      <img class="arrow" src="/assets/images/keyboard-right-arrow-button.png" (click)="toggleShowDocUpload()">
    </div>
    <!-- KYC Pending Status -->
    <div class="new-card primary"
      *ngIf="isReady && !isDeclined && states.customer.kycFlowCompleted && states.customer.kycStatus === 'KycPending'">
      <div class="card-info">
        <h3>KYC Verification pending</h3>
        <div class="desc">Our team will get in touch with you shortly</div>
      </div>
    </div>
    <!-- My Account Link if active loan present -->
    <div class="new-card primary" *ngIf="allActiveGcApplications.length && !googlepayFlowEnabled && !flipkartUltraFlowEnabled">
      <div class="card-info">
        <h3>Manage your active loans</h3>
        <div class="desc">Repayments, order history, credit score and much more</div>
        <div class="footer-wrapper">
          <a (click)="redirectToYourAccountUrl()"><span>Go to My Accounts </span><i
              class="arrow material-icons">chevron_right</i></a>
        </div>
      </div>
    </div>
      <div class='bolt-banners' *ngIf="showBoltCLBanner">
           <img src="https://assets.zestmoney.in/assets/customers/bolt/bolt_logo.png" alt="bolt" />
            <div class="bolt-content">
              <div class="bolt-text">
                <h3 [textContent]="boltMessageHeader" class="card-header"></h3>
               <p [textContent]="boltMessageSub" class="card-para"></p>
              </div>
            <a [target]="boltCtaDetails.target" class="btn zest-btn bolt-learn-more" [textContent]="boltCtaDetails.text" (click)="triggerClick(boltCtaDetails)"></a>
          </div>
        </div>
  </section>
  <section class="file-upload-wrapper" *ngIf="showDocUpload && !isVoucherView">
    <zest-upload-card (close)="toggleShowDocUpload()"></zest-upload-card>
  </section>
  <section class="merchant-section" *ngIf="isReady && states && !isDeclined && !isVoucherView && statusCard?.cardType !== 13 && !flipkartUltraFlowEnabled">
    <zest-merchants-card [states]="states" [clState]="clState" [merchantConfig]="merchantConfig"
      (showAllModal)="showMerchantList()"></zest-merchants-card>
  </section>
  <section class="faqs-section" *ngIf="(!loanCard && clState?.credit_limit?.available_amt && !isVoucherView) || statusCard?.cardType === 13">
    <zest-faqs-card></zest-faqs-card>
  </section>
</main>